import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRouteMembre = ({ children }) => {
  try {
    const membreStr = localStorage.getItem('membre_user');
    
    if (!membreStr) {
      return <Navigate to="/login-membre" replace />;
    }

    // Vérifier que c'est un JSON valide
    const membre = JSON.parse(membreStr);
    
    // Vérifier que le membre a au moins un identifiant
    if (!membre || (!membre.id && !membre.numero_matricule)) {
      localStorage.removeItem('membre_user');
      return <Navigate to="/login-membre" replace />;
    }

    return children;
  } catch (error) {
    console.error('Erreur lors de la vérification du membre:', error);
    localStorage.removeItem('membre_user');
    return <Navigate to="/login-membre" replace />;
  }
};

export default PrivateRouteMembre;


